import { render, staticRenderFns } from "./BillAdd.vue?vue&type=template&id=ca0cf77a&scoped=true"
import script from "./BillAdd.vue?vue&type=script&lang=js"
export * from "./BillAdd.vue?vue&type=script&lang=js"
import style0 from "./BillAdd.vue?vue&type=style&index=0&id=ca0cf77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0cf77a",
  null
  
)

export default component.exports